import { userMonitoringGetWatcherSaga } from './GetByUser.saga'
import { monitoringSendEmailWatcherSaga } from './SendEmail'
import { destroyManyWatcherSaga } from './destroyMany.saga'
import { monitoringUploadWatcherSaga } from './upload.saga'

export const root = [
  userMonitoringGetWatcherSaga(),
  monitoringSendEmailWatcherSaga(),
  destroyManyWatcherSaga(),
  monitoringUploadWatcherSaga(),
]

export default root
